<span class="address-availability__icon icon-time badge-status--<%= status %>"></span>
<span class="address-availability__status badge-status--<%= status %>"><%= statusLabel %></span>
<span class="address-availability__text"><%= statusText %></span>
<span class="address-availability__more-icon icon-dropdown"></span>
